module.exports = "/images/vu.png?9bcca1fed904a578a1b0dcf146f359e8";


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/img/vu.png
// module id = 1GLa
// module chunks = 70